import { cacheName, cache } from '@/utils/cacheManager'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { Message } from '@/utils/Message'
import URL from '@/api/urlTranslator'
import store from '@/store'
import { getToken } from '@/utils/auth' // get token from cookie

export class PrintTemplateManager {
  static FORMAT_HTML = 'HTML';
  static FORMAT_PDF = 'PDF';
  static FORMAT_WORD = 'WORD';
  static FORMAT_RTF = 'RTF';
  static FORMAT_XLS = 'XLS';
  static FORMAT_XLSX = 'XLSX';

  // service url
  static SERVICE_REPORT = `${URL.report.templatePrint}`;
  static SERVICE_FAX = `${URL.report.templateFax}`;

  static PRINT = 'PRINT'; // 打印
  static EMAIL = 'EMAIL'; // 邮件
  static FAX = 'FAX';

  static INSTANCE;
  /**
   * constructor
   */
  constructor() {
    this.commitFlag = true
  }

  /**
   * singleton
   */
  static getInstance() {
    if (!this.INSTANCE) {
      this.INSTANCE = new PrintTemplateManager()
    }
    return this.INSTANCE
  }

  /*
    * To open a new brower window to display a report based on the template and input data - obj.
    * Format can be FORMAT_HTML, or FORMAT_PDF.
    *
    * Parameter template - a Template instance that contains report template info
    */
  // 打印
  static async print(template, documentType, format, parameters, inline = true) {
    await cache.load(cacheName.CONFIG)
    if (!template || !template.templateFile) {
      console.log('v1 print template', template)
      Message.warning('Template must specified.')
      return
    }
    let msg = 'Call Report Service with parameters of'

    const variables = {}
    const sessionId = getToken()
    if (!sessionId || sessionId === 'null') {
      Message.warning('Session过期请重新登录.')
      return
    }

    variables.sessionId = sessionId
    msg = msg + ' sessionId=' + getToken()

    variables.template = template.templateFile
    msg = msg + ' template=' + template.templateFile

    let _templateName = ''
    if (Object.prototype.hasOwnProperty.call(parameters, 'fileAliasName')) {
      _templateName = parameters.fileAliasName
    }

    variables.templateName = template.name
    msg = msg + ' templateName=' + template.name

    variables.templateType = template.templateType
    msg = msg + ' templateType=' + template.templateType

    // 判断是否为国内账单
    if (template.templateType === 'INTERNALBILLING') {
      // 查询基本配置参数
      const isInternalBillInfo = parseInt(cache.config.get('isInternalBillInfo'))
      // isInternalBillInfo=1，表示账单名称由模板名称和账单号组成
      if (isInternalBillInfo === 1) {
        variables.saveTemplateName = _templateName === '' ? template.name : template.name + '_' + _templateName
        msg = msg + ' saveTemplateName=' + '' === _templateName ? template.name : template.name + '_' + _templateName
      }
    }
    variables.documentType = documentType != null ? documentType.code : ''
    msg = msg + ' documentType=' + variables.documentType

    variables.isShared = documentType != null ? documentType.shared : false
    msg = msg + ' isShared=' + variables.isShared

    variables.format = format
    msg = msg + ' format=' + format

    variables.inline = inline ? 'Y' : 'N'
    msg = msg + ' inline=' + variables.inline

    variables.title = parameters.hasOwnProperty('title') ? parameters.title : ''
    msg = msg + ' title=' + variables.title

    variables.address = parameters.hasOwnProperty('address') ? parameters.address : ''
    msg = msg + ' address=' + variables.address

    variables.content = parameters.hasOwnProperty('content') ? parameters.content : ''
    msg = msg + ' content=' + variables.content

    variables.fromEmail = store.getters.userInfo.email
    msg = msg + 'fromEmail=' + store.getters.userInfo.email

    variables.printType = parameters.hasOwnProperty('printType') ? parameters.printType : this.PRINT
    msg = msg + ' printType=' + variables.printType

    if (typeof parameters.isCommitJob !== 'undefined' && parameters.isCommitJob === false) { this.commitFlag = false } else { this.commitFlag = true }

    if (parameters) {
      for (const key in parameters) {
        if (key !== 'printCallBackUrl') {
          variables[key] = parameters[key]
          if (parameters[key] instanceof Array) {
            // 若是数组，转成json
            variables[key] = '@#' + parameters[key].join(',')
          }
          if (parameters[key] instanceof Array) {
            msg = msg + ' ' + key + '=@#' + parameters[key]
          } else {
            msg = msg + ' ' + key + '=' + parameters[key]
          }
        }
      }
    }
    console.log('====V1=>Print=>variables====', variables)
    const url = this.SERVICE_REPORT + '?' + this.toUrlArgs(variables)
    const showPreview = Boolean(variables.showPreview)
    if (variables.printType !== this.PRINT || !showPreview) {
      // 邮件【放在调用print方法的地方处理，在此遇到的困难，1、没法抛出事件2、没法弹出成功失败的提示】
      // const status = await this.loadMailURL(url)
      // if (showPreview) {
      //   this.httpResultEmail(status)
      // } else {
      //   this.profitSubmitHandler(status)
      // }
      return url
    } else {
      await this.navigateToURL(this.SERVICE_REPORT, variables)
    }
    console.log('====V1=>Print=>msg====', msg)
    return null // 如果是邮件发送，则需要返回值，其他情况不需要，返回null即可
  }
  /*
      * fax report ,similar as print .
      *
      * Parameter template - a Template instance that contains report template info
      */
  static async fax(template, format, parameters, inline = true) {
    if (template == null || template.templateFile == null || template.templateFile.length === 0) {
      throw new Error('Template must specified.')
    }
    let msg = 'Call Fax Service with parameters of'
    const variables = {}
    const sessionId = getToken()
    if (!sessionId || sessionId === 'null') {
      throw new ErrorTip('Session过期请重新登录.')
    }

    variables.sessionId = sessionId
    msg = msg + ' sessionId=' + getToken()

    variables.template = template.templateFile
    msg = msg + ' template=' + template.templateFile
    variables.templateName = template.name

    msg = msg + ' templateName=' + template.name
    variables.templateType = template.templateType

    msg = msg + ' templateType=' + template.templateType
    variables.format = format

    msg = msg + ' format=' + format
    variables.faxNo = parameters.hasOwnProperty('faxNo') ? parameters.faxNo : ''
    msg = msg + ' faxNo=' + variables.faxNo

    if (parameters) {
      for (const key of parameters) {
        if (key !== 'printCallBackUrl') {
          variables[key] = parameters[key]
          msg = msg + ' ' + key + '=' + parameters[key]
        }
      }
    }
    console.info(msg)
    await this.navigateToURL(this.SERVICE_FAX, variables)
  }
  static async navigateToURL(URL, PARAMS) {
    const form = document.createElement('form')
    form.action = URL
    form.method = 'post'
    form.style.display = 'none'
    for (const key in PARAMS) {
      const opt = document.createElement('textarea')
      opt.name = key
      opt.value = PARAMS[key]
      form.appendChild(opt)
    }
    form.target = '_blank'
    document.body.appendChild(form)
    form.submit()
  }
  // 参数处理
  static toUrlArgs(data) {
    const needEncode = ['BILLINGNO', 'BILLING_UUID', 'CONFIRM_BILL_UUID', 'CONFIRM_BILL_ID', 'BILL_PAYMENT_UUID', 'BILLPAYMENT_UUID', 'JOB_UUID', 'sessionId', '___SESSION_ID', '___TEMPLATE_UUID', '___RECEIVER_EMAIL', '___STORAGE_FILE_ID', 'cargoDocUuid', 'jobuuid', 'DOC_UUID', 'uuid', 'VGM_UUID', 'FILE_UUID', 'CONTAINER_UUID', 'CUSTOMS_INFO_UUID', 'customsInfo_UUID_List', 'FBA_QUOTATION_UUID_LIST']
    let params = ''
    if (Object.prototype.hasOwnProperty.call(data, 'ctx')) delete data.ctx
    let jobUuidType = ''
    for (const key in data) {
      if (params) {
        params += '&'
      }
      if (key === 'JOB_UUID' && data[key] && Array.isArray(data[key])) {
        jobUuidType = 'Array'
      }
      if (key && data[key] && needEncode.includes(key) && data[key].indexOf('%') < 0) { // 已经加密过就不需要再次加密了，加密过后会带有%
        data[key] = encodeURIComponent(data[key])
      }
      params += key + '=' + data[key]
    }
    if (jobUuidType) params += ('&jobUuidType=' + jobUuidType)
    return params
  }

  // 参数处理【V3单独使用】
  static toUrlArgs2(data, template) {
    const needEncode = ['JOB_UUID', 'sessionId', '___SESSION_ID', '___TEMPLATE_UUID', '___RECEIVER_EMAIL', '___STORAGE_FILE_ID', 'cargoDocUuid', 'jobuuid', 'DOC_UUID', 'uuid', 'VGM_UUID', 'FILE_UUID', 'CONTAINER_UUID', 'CUSTOMS_INFO_UUID', 'customsInfo_UUID_List', 'FBA_QUOTATION_UUID_LIST']
    let params = ''
    if (Object.prototype.hasOwnProperty.call(data, 'ctx')) delete data.ctx
    for (const key in data) {
      if (params) {
        params += '&'
      }
      if (key && data[key] && needEncode.includes(key) && data[key].indexOf('%') < 0 && !(template.engine === 2)) { // 已经加密过就不需要再次加密了，加密过后会带有%
        data[key] = encodeURIComponent(data[key])
      }
      params += key + '=' + data[key]
    }
    return params
  }

  /**
   * 加载MailURLRequest
   */
  static async loadMailURL(urlRequest) {
    let status = -1
    const request = new XMLHttpRequest()
    request.open('GET', urlRequest)
    request.send()
    request.onload = function(e) {
      status = request.status
      console.log('request.status', request.status)
    }
    request.onerror = function(e) {
      this.loadError()
    }
    console.log('request.status1', status)
    return status
  }

  /**
   * Mail异常结果处理
   */
  static httpResultEmail(status) {
    // 附件过大
    if (status === 0) {
      throw new ErrorTip('附件内容过大')
    } else if (status === 1) {
      throw new ErrorTip('SMTP服务器错误')
    } else if (status === 2) {
      throw new ErrorTip('不能连接SMTP服务器')
    } else if (status === 3) {
      throw new ErrorTip('系统找不到指定文件')
    } else if (status === 4) {
      throw new ErrorTip('发送文件出错')
    } else if (status === 5) {
      throw new ErrorTip('附件模板出错')
    } else if (status === 200) {
      console.log('httpResultEmail,邮件发送成功')
    }
  }

  /**
   * @private
   */
  static profitSubmitHandler(status) {
    if (Number(status) === 200 && this.commitFlag) {
      // Alert.show("业务提交成功","提示!"); 【老系统就是屏蔽了的】
    }
  }

  /**
   * 加载URLRequest错误
   */
  static loadError() {
    throw new ErrorTip('加载URLRequest错误')
  }
}
